import  {store as reduxStore, changeLanguageActionForDispatch}  from './../../store.js'
//while it's considered bad practice to import redux store directly, we need to access currentUser data and dispatch from here: a utility function instead of component function...
//later on, move currentUser access to components, only leave dispatch()  or pass in dispatch() from components or do dispatch from components!

import { UserDepot, AppwriteCloudServer } from './MyAppServerDefs'
import { OSSNAPI } from './OSSNAPI'
import validator from 'validator'
import { myIsObject, formatTimestamp, show_link_list, myUrlEncode, myUrlDecode } from '../views/itemviews/GenericItemListContentUtils'
import { parseIBGAttendanceFromOSSN } from './MyAppServerCommUtils'

const docean_OSSNGateServer = {
        host: 'https://ossnapi.tinyshare.info'   //Nginx translates it to :8081
       // host: 'https://app.tier1-ibg.com'   //Nginx translates it to :8081
    };

const dev_appwrite_server = {
        endpoint: 'https://cloud.appwrite.io/v1',
        proj_id:'674dc69f000727ccc93b'
    };
const emailVerificationURL = 'http://app.tier1-ibg.com/#/verification';   // for email registration verificaiton.
const passwordResetURL = 'http://app.tier1-ibg.com/#/ResetPasswordAction';   // for email password recovery
const magicLoginVerificationURL = 'http://app.tier1-ibg.com/#/verification_magiclogin'

export function readUserLoginStatus(){
    const reduxState = reduxStore.getState();
    return reduxState.MyApp.currentUser;
}

function generateUniqueRandomString(length = 8) {
    const chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    let result = '';
    const usedChars = new Set();

    while (result.length < length) {
        const randomIndex = Math.floor(Math.random() * chars.length);
        const randomChar = chars[randomIndex];

        if (!usedChars.has(randomChar)) {
            result += randomChar;
            usedChars.add(randomChar);
        }
    }

    return result;
}

(async ()=>{

//    window.HM_server = new HM_server();
  //bootstrapping:   /////////////////////////////////////////////////////////////////////////////////////
    window.userDepot = new UserDepot(dev_appwrite_server['endpoint'],dev_appwrite_server['proj_id']);
    window.theAppwriteCloudServer = new AppwriteCloudServer(dev_appwrite_server['endpoint'],dev_appwrite_server['proj_id']);

    window.theOSSNAPI            = new OSSNAPI(docean_OSSNGateServer);

    const cachedData_string = localStorage.getItem("ibg_app_config")
    if(cachedData_string){  //note:  userDepot.loginCheck_cb() will take a while to return, so "localStorage" -- if exists -- will make the UI display normally, instead of jumping to "/Login" page.
                                                 //    but this is transient in nature and loginCheck() below should return soon enough to update ...
       // ConfigAppwriteServers(JSON.parse(localStorage.getItem("ibg_app_config")));
       const cachedData = JSON.parse(cachedData_string)
       reduxStore.dispatch({type:'action_localstorage_found',payload:{...cachedData}})
       reduxStore.dispatch(changeLanguageActionForDispatch(cachedData.locale));
    }else{
       // return
        //loginCheck() is needed only if we found  cached localStorage. Otherwise do nothing and the user is strictly directed to default home page.
        //2025.3.5: reversed the above - when magic link logging in for the 1st time, there's no cache so need to do loginCheck() anyways.
    }


    console.log("before loginCheck")

    //  login check: /////////////////////////////////////////////////////////////////////////////////////
    const accountObj = await window.userDepot.loginCheck();
    //const accountObj = await window.theAppwriteCloudServer.accountFetchGQL();
    if( !accountObj) {
        reduxStore.dispatch({type:'action_login_checked_fail',payload:{}})
        return
       }

    //2024.12.3 future proof  -- this is not needed until we want/need to push certain data to users who stay logged on, then we can add some loading / updating here:
    let payload = {'email':accountObj['email']}
    if( 'userType' in accountObj['prefs']){
        payload = {...payload, 'userType': accountObj['prefs']['userType']}
    }

    if( 'avatar' in accountObj['prefs']){
        const avatarFileId = accountObj['prefs']['avatar']
        const avatar = window.userDepot.getAvatarLink(avatarFileId)
        payload = {...payload, 'avatar': avatar}
    }

    if( 'locale' in accountObj['prefs']){
        payload = {...payload, 'locale': accountObj['prefs']['locale']}
        reduxStore.dispatch(changeLanguageActionForDispatch(payload.locale));
    }

    if( 'ossnId' in accountObj['prefs']){
        let ossnId = accountObj['prefs']['ossnId']
        if(typeof accountObj['prefs']['ossnId'] === 'string'){
            ossnId = parseInt(ossnId)
        }
        payload = {...payload, 'ossnId': ossnId}

    }

    const a = import.meta.env.VITE_APP_VERSION
    const b = accountObj['appVersionLatest']

    if( b && a && b > a){
       //this condition requires: never update accountObj['appVersionLatest'] on Appwrite cloud server ahead of app client side.

        const cached_data = {userType:userType, locale: locale, avatar: avatar, appVersionLatest:b}
        localStorage.setItem('ibg_app_config',JSON.stringify(cached_data))
        //not critical as we don't use the cached version of appVersionLatest, but update it anyway

        window.location.reload()
    }
    else 
        reduxStore.dispatch({type:'action_login_checked',payload:payload})
})();


export async function MyAppHandleRegistration(userType, userEmail, password,password2, navigate_cb){

    //   validation:
    //email
    if( !validator.isEmail(userEmail)){
        alert("Please double check your email format.\n\n" + userEmail +": does not seem to be a valid email address.")
        return
    }
    if( !password || !password2 ||  (password.length < 4)){
        alert("Password error. \n\nPassword need to be at least 4 characters long.")
        return
    }else if((password.length != password2.length) || password !== password2){
        alert("Password error. \n\nPassword repeat failed.")
        return
    }

    try{
        const response = await window.userDepot.create("unique()", userEmail, password);
        let data = {}
        data['uid']=response['$id']; data['email']=response['email']
        const status = response['status']
        console.log("Account Registration Results:" + JSON.stringify(response))

         // Create a session for the user
        const response_create_session = await window.userDepot.createEmailSession(userEmail, password);

        //set user type:
        const response_setUserType = await window.userDepot.updatePrefs({"userType":  userType} )

        //todo:  add error checking
        const cached_data = {"userType":userType}
        localStorage.setItem('ibg_app_config',JSON.stringify(cached_data))
        reduxStore.dispatch({type:'action_login_success',payload:{'email':userEmail,'userType':userType}})
        console.log("result:" + JSON.stringify(response_create_session))

        // Send verification email
        const response_create_verification = await window.userDepot.createVerification(emailVerificationURL); // Replace with your verification URL
        console.log("result:" + JSON.stringify(response_create_verification));
        if(response['status']){
            navigate_cb()
        }

    }catch(error){
        console.log(error); // Failure
        alert("Registration failed. Please try again.\n" + error);
    }
}

export async function MyAppHandleVerificationMagicLogin(userId, secret, navigate_cb){
    try{
        // Send verification email
        //const result = await window.theAppwriteCloudServer.updateMagicURLSession(userId, secret)  2025.3.5 verified: not working.
        const result = await window.theAppwriteCloudServer.createSession(userId, secret)
        return result

    }catch(error){
        console.log(error); // Failure
        alert("Verification failed. Please try again.\n" + error.message);
    }
}

export async function MyAppHandleVerification(userId, secret, navigate_cb){

    try{
        // Send verification email
        const result = await window.userDepot.updateVerification(userId, secret)

    }catch(error){
        console.log(error); // Failure
        alert("Verification failed. Please try again.\n" + error);
    }
}

async function SetServerAllocation(data){

//future proof design: assume now that ALL user registrations are handled by ONE public server, and after registration success, the user requests public server API (fastcgi/python)
// to set up AppWrite server for the new user, and save configurations on server. For future load balancing, these configurations can be rearranged when the user is offline.
//
    try{
       const response1 = await window.HM_server.home_fetch('set_config',data)
       const response  = await response1.json()
       console.log(response)
       return true
    }catch(err){
        alert("Error occurred during registration:" + err)
        return false
    }
}


export function MyAppHandleLogout(){

    const currentUser = readUserLoginStatus()
    if ( !currentUser['loginStatus']){
        alert("Already logged out!")
        return;
    }

    window.userDepot.deleteSession('current')

    localStorage.removeItem('ibg_app_config');
    //clearServerConfig();
    reduxStore.dispatch({type:'action_logout_reset_state'});
}


export async function MyAppHandleMagicLinkLogin(email){
    if( !validator.isEmail(email)){
        alert("Please enter your Email\n请输入 Email.")
        return;
    }
    const result = await window.theAppwriteCloudServer.createMaticURLToken(email, magicLoginVerificationURL)

}

export async function MyAppHandleLogin(email,password, navigate_cb){
    //to do: add input validation, 'loginName' needs to be valid email address.

    //2024.12.3 where to go upon login success?  hardcode here, hoist up later.
    //const navigateOnSuccess = () => navigate_cb("/servorderlist/mine", { replace: true })

    //add validation guard:
    if( !validator.isEmail(email) || !password){
        alert("email / password are required.")
        return;
    }


    let userType = 'student'   //default to "student"
    let locale = 'zh-CN'
    let avatar = ''
    let appVersionLatest = ''

    try{
        const response_login = await window.userDepot.createEmailSession(email,password);
       // reduxStore.dispatch({type:'action_login_success',payload:{'email':email}})
        //navigateOnSuccess()
        const userId = response_login['userId']
        const response_prefs = await window.userDepot.getPrefs();
        //const accountObj = await window.theAppwriteCloudServer.accountFetchGQL();
        //const response_prefs = accountObj.prefs
        //const testResponse = await window.theAppwriteCloudServer.getPrefs()
        if ("userType" in response_prefs){
            userType = response_prefs.userType
        }
        if( 'avatar' in response_prefs){
            const avatarFileId = response_prefs.avatar
            avatar = window.userDepot.getAvatarLink(avatarFileId)
        }
        if ("locale" in response_prefs){
            locale = response_prefs.locale
        }

        if(typeof accountObj !== "undefined" &&  "appVersionLatest" in accountObj){
            appVersionLatest = accountObj['appVersionLatest']
        }

        //userType = response_prefs
        console.log("logged in")
    }catch(err){
        if(err.type !== "user_session_already_exists"){
         //   reduxStore.dispatch({type:'action_login_success',payload:{'email':email}})
            alert("Log in failed. Please try again.\n" + err);
            return
        }
    }

    const cached_data = {userType:userType, locale: locale, avatar: avatar, appVersionLatest:appVersionLatest}
    localStorage.setItem('ibg_app_config',JSON.stringify(cached_data))
    reduxStore.dispatch({type:'action_login_success',payload:{email:email,...cached_data}})
    reduxStore.dispatch(changeLanguageActionForDispatch(locale));

    //navigateOnSuccess()
}

export async function MyAppHandleForgotPassword(email){
     //add validation guard:
    if( !validator.isEmail(email) ){
        alert("Please enter a valid email.")
        return false;
    }

    window.userDepot.createRecovery(email, passwordResetURL);

   return true
}


export async function MyAppHandleResetPasswordAction(userId, secret, password,password2){
   if( !password || !password2 ||  (password.length < 4)){
        alert("Password error. \n\nPassword need to be at least 4 characters long.")
        return false
    }else if((password.length != password2.length) || password !== password2){
        alert("Password error. \n\nPassword repeat failed.")
        return false
    }

     try{
        const result  = await window.userDepot.updateRecovery(userId, secret, password,password2)
     }catch(err){
            alert("Rest password failed. Please try again.\n" + err);
            return false
    }

   return true
}


export async function createProfile(userType,data){
    return await window.theAppwriteCloudServer.createProfile(userType,data)
}

export async function updateProfile(userType,docId, data){
    return await window.theAppwriteCloudServer.updateProfile(userType,docId,data)
}

export async function loadProfileByEmail(userType, email){
    return await window.theAppwriteCloudServer.loadProfileByEmail(userType, email)
    //return await window.theAppwriteCloudServer.loadProfileByEmailGQL(userType, email)
}

export async function uploadAccountLocale(newLocale){
    const prefs = await window.userDepot.getPrefs()
    const newPrefs = {...prefs, "locale": newLocale}
    const response_prefs = await window.userDepot.updatePrefs(newPrefs);
    return response_prefs
}

function __________________delimiter____________________(){}

export async function ReloadProfileList(userType){
    const serverLoadedList = await window.theAppwriteCloudServer.loadProfileList(userType)
    if( userType === 'student'){
        reduxStore.dispatch({type:'action_student_list_loaded',payload:{student_list: serverLoadedList}})
    }else if( userType === 'coach'){
        reduxStore.dispatch({type:'action_coach_list_loaded',payload:{coach_list: serverLoadedList}})
    }else{
        alert("Error: should not reached here. MyAppServerComm::ReloadProfileList()")
    }
}


async function RoadProfileListByUserIds(userType, extractedUserIds){
    const serverLoadedList = await window.theAppwriteCloudServer.loadProfileListByEmails(userType, extractedUserIds)
    return serverLoadedList
}



function __________________delimiter2____________________(){}



export async function createOnePostToServer(data){
    const isReplyPost = (data.parentId  && data.parentId !== '')
    let existingReplyCount =0
    if(isReplyPost ){
        existingReplyCount = await window.theAppwriteCloudServer.countPostChildren(data.parentId)
        // 2024.12.30 important: loading actual counts of children each time, makes childCountData updating  forgiving -- even if race conditions occurr, next update will set it right.
    }

    const createResult =  await window.theAppwriteCloudServer.createPost(data)

    if(isReplyPost){
        const childCountData = { childCount: existingReplyCount+1}
        await window.theAppwriteCloudServer.updatePost(data.parentId, childCountData)
    }
    return createResult
}

export async function updateOnePostToServer(docId, data){
    return await window.theAppwriteCloudServer.updatePost(docId,data)
}

export async function deleteOnePostFromServer(docId, parentDocId){
    const isReplyPost = (parentDocId  && parentDocId !== '')
    let existingReplyCount =0
    if(isReplyPost ){
        existingReplyCount = await window.theAppwriteCloudServer.countPostChildren(parentDocId)
    }
    const deleteResult = await window.theAppwriteCloudServer.deletePost(docId)
    if(isReplyPost && existingReplyCount > 0 ){
        const childCountData = { childCount: existingReplyCount-1}
        const updateResult = await window.theAppwriteCloudServer.updatePost(parentDocId, childCountData)
        console.log("updating childCount:" + JSON.stringify(updateResult))
    }
    return deleteResult
}

export async function loadOnePostFromServer(docId){
    return await window.theAppwriteCloudServer.loadOnePost(docId, email)
    //return await window.theAppwriteCloudServer.loadProfileByEmailGQL(userType, email)
}


// key fields in a OSSN post:
//  description: the main content.
//  title:
//  guid:
// owner_guid: owner of the wall or group
// type/subtype:
// poster_guid: could be the same as owner
// user details:  owner.

export async function ReloadPlayerListIBG(groupName, offset_in, asUtilFunc=false){
    // piecemeal dev price:  "Player" is not a "Post", but following processing of "posts"

    let allPosts = []; // Stores all merged results
    let currentOffset = offset_in; // Track the current offset
    let totalCount = 0; // Total expected records
    let serverLoadedList;
    let results;

    do {
        results = await window.theOSSNAPI.loadOSSNIBGPlayerList(groupName, currentOffset);

        // Exit if the API response is invalid
        if (results.ossn_code !== "100") break;

        serverLoadedList = results.data.payload.posts;
        totalCount = results.data.payload.count; // Total records expected

        // Merge the new results with existing data
        if(totalCount > 0){
            allPosts = [...allPosts, ...serverLoadedList];
        }

        // Update offset for the next API call (next page)
        currentOffset = parseInt(results.data.payload.offset) + 1;

        // Exit if no more data or we've fetched all
        if (serverLoadedList.length === 0 || allPosts.length >= totalCount) break;

    } while (allPosts.length < totalCount);

     //const serverLoadedList = results["data"]["payload"]["posts"]
    // const totalCount = results["data"]["payload"]["count"]
     //const offset = results["data"]["payload"]["offset"]

    const parsedList = allPosts.map(
            (item, idx)=> {
                if( !item) return {}

                const ossn_content = item["post"]["description"]
                //#const ossn_content_obj = JSON.parse(ossn_content)
                //#const payload = ossn_content_obj["post"]
                const payload_decoded = myUrlDecode(ossn_content)
                const item_obj = JSON.parse(payload_decoded)

                const newItem = {...item_obj, 'ossn_post_id': item['post']['guid']}
                return newItem;
            }
        )    

    if( asUtilFunc ){
        //we need to use this as a utility function to load player data, when loading attendance data (so as to dynamically access player info.)
        return {totalPlayerCount: totalCount, playerListData: parsedList}
    }else{
        reduxStore.dispatch({type:'action_post_list_loaded',payload:{ post_list:        parsedList,
                                                                  total_count_filtered: totalCount,
                                                                  filter:               groupName,
                                                                  currentPageNum:       currentOffset
                                                          }})
    }
}
function _____________delimiter3_1______________(){}

export async function createOSSNIBGPlayer(playerlistCodename, ossn_post_text_encoded){
    const result = await window.theOSSNAPI.createOSSNIBGPlayer(playerlistCodename, ossn_post_text_encoded)
    return result
}


export async function createOSSNIBGPlayerRecursively(playerlistCodename, text_array){
    const texts = [...text_array]
    if (texts.length === 0) {
        return Promise.resolve();
    }
    // Remove the first element from the array
    const text = texts.shift();
    const response =  await createOSSNIBGPlayer(playerlistCodename, text);
    console.log(response);
    const response_further = await createOSSNIBGPlayerRecursively(playerlistCodename, texts);
    return response_further
}



export async function updateOSSNIBGPlayer(ossn_post_id, ossn_post_text_encoded){
   const result = await window.theOSSNAPI.updateOSSNIBGPlayer(ossn_post_id, ossn_post_text_encoded)
   return result
}

function _____________delimiter4______________(){}

//ReloadAttendanceListIBG() is a specialized version of ReloadPostListOSSN(): add extra loading of player data & merging.
export async function ReloadAttendanceListIBG(ossnGroupCodeName, attendanceMonth){

    //2025.3.12 code refactoring for easier reading:  use ossnGroupCodeName (OSSN centric, a code name representation of a group on OSSN server) to replace "filter", react app UI (sidebar nav) & store.js centric.
   //2025.2.3:  filter: OSSN group name;  emailFilter: ignore for now.

    //const loadingResults = await window.theOSSNAPI.loadOSSNPostList( ossnGroupCodeName)
    const loadingResults = await window.theOSSNAPI.loadOSSNPostListEx( ossnGroupCodeName, null, null)
    if( loadingResults['status_code'] !== 200 || loadingResults['ossn_code'] !== "100"){
        console.log("Error loadOSSNPostList(). " + loadingResults.headers)
    }

    const data = loadingResults.data.payload
    const offset = data.offset
    const count = data.count
    const posts = data.posts

    const totalCount       = count
    const serverLoadedList = data.posts
    if(!serverLoadedList || serverLoadedList.length === 0 ){
         reduxStore.dispatch({type:'action_post_list_loaded',payload:{post_list: [],filter:ossnGroupCodeName, currentPageNum: offset}})
         return
        }

    const parsedAttendanceList_unfiltered = parseIBGAttendanceFromOSSN(serverLoadedList)
    const parsedAttendanceList = parsedAttendanceList_unfiltered.filter((item)=>{ return item.dateFor.startsWith(attendanceMonth)})
//    const playerListingGroupName = ossnGroupCodeName === 'ibg_attendance_nbtc'? "playerlisting_nbtc" : "playerlisting"  //2026.2.17 ducttape fix

    const ossnGroup_Attendance_vs_playerListing = {
            ibg_attendance: 'playerlisting',
            ibg_attendance_nbtc: 'playerlisting_nbtc',
            ibg_attendance_nbtc_block2: 'playerlisting_nbtc_block2',
            }
    const playerListingGroupName = ossnGroup_Attendance_vs_playerListing[ossnGroupCodeName] || 'playerlisting';


    const {totalPlayerCount, playerListData }= await ReloadPlayerListIBG(playerListingGroupName, 1, true)

    const replacePlayerNameField = (targetObj)=>{
        const itemFound = playerListData.find((item)=>{ return item.id === targetObj.playerId })
        if( itemFound){
            //2025.3.3 hack:  designate new program kids with "(B)" -- rate===100. Others with "(A)". "(C)" is also planned in the future. 86 for Emmi/Evan V, discounted.
            let category_suffix = "(A)"
            if (itemFound.rate === 100 || itemFound.rate === 86 || itemFound.rate === 95){
                category_suffix = "(B)"
            }
            targetObj.playerName = itemFound.name + " " + category_suffix
        }
        return
    }

    // for each player in the attendance list, update his/her name from playerListData
    parsedAttendanceList.forEach(
      (item,index)=>{
          item.absent_list.forEach( (item)=> {replacePlayerNameField(item)});
          item.present_list.forEach( (item)=> {replacePlayerNameField(item)});
      })

    //2026.2.18 patch: if a player is not in the present_list AND absent_list: then it must have been added to the PlayerList directly, so we add to the absent_list
    // -- don't do it, here, do it when "edit / duplicate" a post.
    


    reduxStore.dispatch({type:'action_post_list_loaded',payload:{ post_list:            parsedAttendanceList,
                                                                  player_list:          playerListData,
                                                                  total_count_filtered: totalCount,
                                                                  filter:               ossnGroupCodeName,
                                                                  currentPageNum:       offset
                                                                  }})
}

export async function ReloadPostListOSSN(ossnGroupCodeName,pageSize, pageNum){

    //2025.3.12 code refactoring for easier reading:  use ossnGroupCodeName (OSSN centric, a code name representation of a group on OSSN server) to replace "filter", react app UI (sidebar nav) & store.js centric.
    //2025.2.3:  filter: OSSN group name;  emailFilter: ignore for now.

    const loadingResults = await window.theOSSNAPI.loadOSSNPostList( ossnGroupCodeName, pageSize, pageNum)
    if( loadingResults['status_code'] !== 200 || loadingResults['ossn_code'] !== "100"){
        console.log("Error loadOSSNPostList(). " + loadingResults.headers)
    }

    const data = loadingResults.data.payload
    const offset = data.offset
    const count = data.count
    const posts = data.posts

    const totalCount       = count
    const serverLoadedList = data.posts
    if(!serverLoadedList || serverLoadedList.length === 0 ){
         reduxStore.dispatch({type:'action_post_list_loaded',payload:{post_list: [],filter:ossnGroupCodeName, currentPageNum: pageNum}})
         return
        }

    reduxStore.dispatch({type:'action_post_list_loaded',payload:{ post_list:            serverLoadedList,
                                                                  total_count_filtered: totalCount,
                                                                  filter:               ossnGroupCodeName,
                                                                  currentPageNum:       offset
                                                                  }})
}


function _____________delimiter5______________(){}
export async function deleteIBGAttendanceOSSNPost(post_guid, poster_guid ){
    const result = await window.theOSSNAPI.deleteIBGAttendanceOSSNPost( post_guid, poster_guid)
    return result
}



export async function createIBGAttendanceOSSNPost(groupCodename, poster_guid, text){
    const result = await window.theOSSNAPI.createIBGAttendanceOSSNPost(groupCodename, poster_guid, text)
    return result
}

export async function updateIBGAttendanceOSSNPost(post_guid, poster_guid, text){
     const result = await window.theOSSNAPI.updateIBGAttendanceOSSNPost(post_guid, poster_guid, text)
     return result
}

function _____________delimiter6______________(){}
export async function createIBGChatroomOSSNPost(chatroomCodename, poster_guid, text){
     const result = await window.theOSSNAPI.createIBGChatroomOSSNPost(chatroomCodename, poster_guid, text)
     return result
}

export async function createIBGChatroomOSSNPostReply(post_guid, commenter_guid, text){
     const result = await window.theOSSNAPI.createIBGChatroomOSSNPostReply(post_guid, commenter_guid, text)
     return result
}



export async function updateIBGChatroomOSSNPost(post_guid, poster_guid, text){
     const result = await window.theOSSNAPI.updateIBGChatroomOSSNPost(post_guid, poster_guid, text)
     return result
}

export async function updateIBGChatroomOSSNPostReply(reply_guid, text){
     const result = await window.theOSSNAPI.updateIBGChatroomOSSNPostReply(reply_guid, text)
     return result
}

export async function deleteIBGChatroomOSSNPost(post_guid, poster_guid){
     const result = await window.theOSSNAPI.deleteIBGChatroomOSSNPost(post_guid, poster_guid)
     return result
}

export async function deleteIBGChatroomOSSNPostReply(reply_guid, replyer_guid ){
    const result = await window.theOSSNAPI.deleteIBGChatroomOSSNPostReply(reply_guid, replyer_guid)
    return result
}


export async function UploadFileToAppwrite(fileToUpload){
    const results = await window.theAppwriteCloudServer.uploadFileToAppwriteCloud(fileToUpload)

    const fileId = results.$id
    const fileName = results.name
    //const {urlFileView, urlFilePreview, urlFileDownload} = uploadedFileURLS()
    const fileURLs = window.theAppwriteCloudServer.uploadedFileURLS(fileId)
    const fileLinks = {fileName, fileURLs}
    return fileLinks
}

function _____________delimiter7______________(){}

export async function ReloadPostList(emailFilter,filter,pageSize, pageNum){

    //2025.1.11 hack - if emailFilter is not empty, ignore filter; otherwise, use filter (which for now contains value for 'AllowedViewers'
    const loadingResults = await window.theAppwriteCloudServer.loadPostList(emailFilter, filter, pageSize, pageNum)
    const totalCount       = loadingResults['total']
    const serverLoadedList = loadingResults['documents']
    if(!serverLoadedList || serverLoadedList.length === 0 ){
         reduxStore.dispatch({type:'action_post_list_loaded',payload:{post_list: [],filter:filter, currentPageNum: pageNum}})
         return
        }

    //extract userID into an array, then load "Profile" docs, then extract "Name", then add "Name" field to serverLoadedList.
    const extractedUserIds = [...new Set(serverLoadedList.map(obj => obj.userId))];
    const userProfileList = await RoadProfileListByUserIds('student', extractedUserIds)

    const translateUserIdtoUserName = (aUserId)=> {
        if( !userProfileList ) return ''
        const foundObject = userProfileList.find(obj => obj.Email === aUserId);
        const name_n_avatar = foundObject ? {Name:foundObject.Name , avatar: window.userDepot.getAvatarLink(foundObject.avatar)} : {}
        return name_n_avatar;
    }
    
    const serverLoadedList_addNameField = serverLoadedList.map((obj)=> ({...obj, ...translateUserIdtoUserName(obj.userId) }))

    reduxStore.dispatch({type:'action_post_list_loaded',payload:{ post_list:            serverLoadedList_addNameField,
                                                                  total_count_filtered: totalCount,
                                                                  filter:               filter,
                                                                  currentPageNum:       pageNum
                                                                  }})
}

export async function  ReloadRepliesOfOnePost(parentPostId){
    const serverLoadedList = await window.theAppwriteCloudServer.loadRepliesOfOnePost(parentPostId)
    if ( serverLoadedList.length > 0) {
        serverLoadedList.forEach(
             (obj)=>{
                if(obj.hasOwnProperty('userId') && obj.userId === 'eliot.teltscher@ibgtennis.com'){
                    obj['avatar'] =   window.userDepot.getAvatarLink('676c4365000597847899')  //2025.1.13 duct tape hack for now. Fetch from server later.
                }
            }
        )
        reduxStore.dispatch({type:'action_post_replies_loaded',payload:{parentPostId:parentPostId, post_replies: serverLoadedList}})
    }
}


export async function  ReloadRepliesOfOnePostOSSN(parentPostId, user_guid){
    const results = await window.theOSSNAPI.loadRepliesOfOnePostOSSN(parentPostId, user_guid)
    if( results['status_code'] !== 200 || results['ossn_code'] !== '100'){
        console.log("Error ReloadRepliesOfOnePostOSSN:" + JSON.stringify(results))
        return
    }

    const serverLoadedList  =  results['data']['payload']['comments']
    if ( serverLoadedList.length > 0) {
        reduxStore.dispatch({type:'action_post_replies_loaded',payload:{parentPostId:parentPostId, post_replies: serverLoadedList}})
    }
}

export async function ReloadOnePost(postId, currentUser){
    if (!postId) return
    const serverLoadedPost = await window.theAppwriteCloudServer.loadOnePost(postId)
    if( !serverLoadedPost) return

    if( currentUser.loginStatus){
    //2025.1.11 added this, so that we can still display One Post for not-logged-in viewers, like a potential client for a gig service provider.
        const extractedUserIds = [serverLoadedPost.userId];
        const userProfileList = await RoadProfileListByUserIds('student', extractedUserIds)
        const translateUserIdtoUserName = (aUserId)=> {
            if( !userProfileList ) return ''
            const foundObject = userProfileList.find(obj => obj.Email === aUserId);
            return foundObject ? foundObject.Name : null;
        }
        serverLoadedPost['Name'] = translateUserIdtoUserName(serverLoadedPost['userId'])
    }
    const serverLoadedPostdata = serverLoadedPost
    reduxStore.dispatch({type:'action_post_one_loaded',payload:{postId: postId, postContent:serverLoadedPostdata }})
}

export async function getAvatarURL(avatarFileId){
    if(!avatarFileId) return null
    return await window.userDepot.getAvatarLink(avatarFileId)
}